import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortBy'
})
export class ArraySortPipe  implements PipeTransform {
  transform(array: any, field: string, secondaryField?: string): any[] {
    if (!Array.isArray(array)) {
      return;
    }
    array.sort((a: any, b: any) => {

      // sort first by the primary field's value
      let aVal = this.getValue(a, field);
      let bVal = this.getValue(b, field);
      
      if (aVal < bVal) {
        return -1;
      }
      if (aVal > bVal) {
        return 1;
      }

      // both values are equal: try to sort by the secondaryField's value, if it is provided
      if (!!secondaryField) {
        aVal = this.getValue(a, secondaryField);
        bVal = this.getValue(b, secondaryField);

        if (aVal < bVal) {
          return -1;
        }
        if (aVal > bVal) {
          return 1;
        }

      }

      return 0;

    });
    return array;
  }

  getValue(obj: any, field: string) {

    if (obj.hasOwnProperty(field)) {
      return obj[field];
    }
    
    return null;
  }
}
